import React, { useEffect, useState } from "react";
import Input from "../../controls/Input";
import CustomTable from "../../controls/CustomTable";
import { fetchGlobalCatalog } from "../../../api/globalcatalogue";
import { useNavigate } from "react-router-dom";
import CustomDrawer from "../../controls/CustomDrawer";
import Button from "../../controls/Button";
import IconButton from "../../controls/IconButton";
import Icon from "../../../assets/icons/Icon";

function Cataloguesearchdrawer({barcode, setDrawer, globalCatalogueData }) {
  const [query, setQuery] = useState(barcode || ""); // State for search query
  const [items, setItems] = useState([]); // State to hold all products
  const [selectedOption, setSelectedOption] = useState("barcode"); // Default to "open"
  const [loading,setLoading]=useState(false);

  const navigate = useNavigate();
  const fetchData = async (selectedOption) => {
    setLoading(true);
    try {

      let response;
      // if (query.trim() !== "") {
        // If there's a query, fetch data based on it
        response = await fetchGlobalCatalog(selectedOption, query);
      // } else {
      //   // If the query is empty, fetch data using a default value or empty query
      //   response = await fetchGlobalCatalog(selectedOption); // Or you can pass a default search term here if needed
      // }
      console.log("response from global catalogue", response);
      setItems(response); // Set the fetched data to state
    } catch (err) {
      console.error("Error fetching global data:", err);
      setItems([]); // Clear items in case of an error
    }
    finally{setLoading(false);}
  };

  // Fetch data whenever selectedOption changes
  useEffect(() => {
    fetchData(selectedOption);
    console.log("selectedoption", selectedOption);

  }, [selectedOption]); // Dependency array with selectedOption



  // Handle saving the selected product
  const handleSelect = (product) => {
    // navigate(`/catalogue/product/Addproduct`, { state: { product } });
    globalCatalogueData(product);
    setDrawer(false); // Close the drawer after selecting a product
  };

  // Columns for the table
  const columns = [
    {headerName:"",field:"ProductImages[0]",type:"image"},
      {
      field: "ProductDetails",
      headerName: "Product Details",
      renderCell: ({ row }) => (
        <div>
          <div className="font-semibold">{row.name}</div>
          <div className="">{row.Code}</div>
          <div className="">MRP:{row.MRP}</div>

        </div>
      ),
    },
    {
      field: "select",
      headerName: "",
      renderCell: ({ row }) => (
     
           <IconButton
                onClick={() => {  handleSelect(row) }}
                bgColor="#F5F5F5"
                textColor="#5e5e5e"
                newhover={true}
                infoText={"Select"}

              >
                <Icon type="add" />
              </IconButton>
       
      ),
    },
  ];

  // Map filtered data to table rows
  const rows = items.map((item) => ({
    key: item._id,
    name: item._source.Name + " " + item._source.Quantity + " " + item._source.UOM,
    ...item._source
  }));

  return (
    <CustomDrawer
      setDrawer={setDrawer}
      drawerWidth="sm:w-[500px]"
      title="Global Catalogue"
    >
      <div className="flex flex-col gap-5 m-1.5 ">
        <div className="flex flex-col gap-4">
          <div className="flex gap-5">
            <Input
              placeholder="search by product name or code"
              value={query}
              onChange={(e) => setQuery(e.target.value)} // Update the search query
            />
            <Button
              type="primary" iconType={"search"} onClick={()=>{fetchData()}}>Search</Button>
          </div>
{/* 
          <div className="flex items-center">
            <input
              id="default-radio-1"
              type="radio"
              value="open"
              name="product-type"
              checked={selectedOption === "open"}
              onChange={() => setSelectedOption("open")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
            />
            <label
              htmlFor="default-radio-1"
              className="ml-2  text-[#000000]"

            >
              Search for non-branded items such as rice, wheat, eggs, tomatoes, etc.
            </label>
          </div> */}

          {/* <div className="flex items-center">
            <input
              id="default-radio-2"
              type="radio"
              value="barcode"
              name="product-type"
              checked={selectedOption === "barcode"}
              onChange={() => setSelectedOption("barcode")}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
            />
            <label
              htmlFor="default-radio-2"
              className="ml-2  text-[#000000]"

            >
              Search for standard FMCG items with EAN codes, such as packaged goods
              and branded products.
            </label>
          </div> */}

        
            
                <CustomTable columns={columns} rows={rows} loading={loading} showTextOnRows={rows.length>0?null:"No records found"} />
            
      
        </div>
      </div>
    </CustomDrawer>
  );
}

export default Cataloguesearchdrawer;